
require("./../../node_modules/@module-federation/nextjs-mf/src/include-defaults.js");

    import dynamic from "next/dynamic"
    const AsyncBoundary = dynamic(() => import("./_app.jsx?hasBoundary"), {suspense:true});
    export default AsyncBoundary;
    

    AsyncBoundary.getInitialProps = async (ctx) => {
      return import("./_app.jsx?hasBoundary").then((mod) => {
        const page = mod.default || mod;
        return page.getInitialProps(ctx)
      })
    }
    